import script from "./Subdomain.vue?vue&type=script&setup=true&lang=ts"
export * from "./Subdomain.vue?vue&type=script&setup=true&lang=ts"

import "./Subdomain.vue?vue&type=style&index=0&id=50f86ff5&lang=css"

const __exports__ = script;

export default __exports__